import React from "react";

const DefaultCurrencyFormat = ({ value, Symbol, ...props }) => {
  const obj = {
    "₺": "TRY",
    $: "USD",
    "€": "EUR",
    "£": "GBP",
  };
  const formattedValue = new Intl.NumberFormat(process.env.NEXT_PUBLIC_LANGUAGE === "en" ? "en-GB" : "tr-TR", {
    style: "currency",
    currency: obj[Symbol],
    minimumFractionDigits: 0,
  }).format(value);

  return <>{formattedValue}</>;
  //return <></>;
  //if (Symbol == "₺")
  //  return (
  //    <CurrencyFormat
  //      value={value}
  //      displayType={"text"}
  //      thousandSeparator={"."}
  //      decimalSeparator={","}
  //      suffix={Symbol}
  //      {...props}
  //      renderText={(value) => <>{value}</>}
  //    />
  //  );
  //return (
  //  <CurrencyFormat
  //    value={value}
  //    displayType={"text"}
  //    thousandSeparator={"."}
  //    decimalSeparator={","}
  //    prefix={Symbol}
  //    {...props}
  //    renderText={(value) => <>{value}</>}
  //  />
  //);
};

export default DefaultCurrencyFormat;
